const LOCAL_STORE_KEY_LANG = 'lang';
const KEY_DEBUG = 'debug';
const KEY_I18N = 'i18n';

export const DEFAULT_LANG = "en";

export function getLang(): string {
    const parameterValue = new URLSearchParams(document.location.search).get(LOCAL_STORE_KEY_LANG);
    const localStorageValue = localStorage.getItem(LOCAL_STORE_KEY_LANG);

    if (parameterValue !== undefined && parameterValue !== null) {
        localStorage.setItem(LOCAL_STORE_KEY_LANG, parameterValue);
        return parameterValue;
    } else if (localStorageValue !== undefined && localStorageValue !== null) {
        return localStorageValue;
    } else {
        return DEFAULT_LANG;
    }
}

export function getDebug(): boolean {
    const parameterValue = new URLSearchParams(document.location.search).get(KEY_DEBUG);

    if (parameterValue !== undefined && parameterValue !== null) {
        return parameterValue.toLowerCase() === "true";
    } else {
        return false;
    }
}

export function getI18n(): boolean {
    const parameterValue = new URLSearchParams(document.location.search).get(KEY_I18N);

    if (parameterValue !== undefined && parameterValue !== null) {
        return parameterValue.toLowerCase() === "true";
    } else {
        return true;
    }
}

export function getInitialData<T>(key: string, emptyData: T): T {
    const localStorageValue = localStorage.getItem(key);

    if (localStorageValue !== undefined && localStorageValue !== null) {
        return JSON.parse(localStorageValue);
    } else {
        return emptyData;
    }
}
